import { CartLinesUpdateEvent } from '@shopify/events';
import { fetchConfig } from '@theme/utilities';

class NemiCartLine extends HTMLElement {
  async update(quantity, change, attributes) {
    const button = this.querySelector('button');
    if (button) button.disabled = true;
    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(new CartLinesUpdateEvent({ ...change, context: 'cart', promise: deferred.promise }));
    try {
      const response = await fetch(
        Theme.routes.cart_update_url,
        fetchConfig('json', {
          body: JSON.stringify({
            updates: { [this.dataset.variantId]: quantity },
            ...(attributes && { attributes }),
            sections: 'cart-drawer-section',
            sections_url: window.location.pathname,
          }),
        })
      );
      const cart = await response.json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { sections: cart.sections, items: cart.items, itemCount: cart.item_count, source: this.localName, didError: false },
      });
    } catch (error) {
      deferred.reject(error);
    } finally {
      if (button) button.disabled = false;
    }
  }
}

class NemiProtection extends NemiCartLine {
  static observedAttributes = ['data-orphan', 'data-auto'];
  #synced = null;

  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.#sync();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  attributeChangedCallback() {
    this.#sync();
  }

  #onClick = () => {
    const button = this.querySelector('button');
    if (!button || button.disabled) return;
    const on = button.getAttribute('aria-checked') !== 'true';
    button.setAttribute('aria-checked', String(on));
    this.#set(on ? 1 : 0, { nemi_protection_off: on ? '' : 'yes' });
  };

  #sync() {
    const quantity = this.hasAttribute('data-orphan') ? 0 : this.hasAttribute('data-auto') ? 1 : null;
    if (quantity === null || quantity === this.#synced) return;
    this.#synced = quantity;
    this.#set(quantity);
  }

  #set(quantity, attributes) {
    return this.update(
      quantity,
      quantity
        ? { action: 'add', lines: [{ merchandiseId: this.dataset.variantId, quantity }] }
        : { action: 'remove', lines: [{ id: this.dataset.key ?? '', quantity: 0 }] },
      attributes
    );
  }
}

class NemiAddBand extends NemiCartLine {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    const button = event.target instanceof Element && event.target.closest('button');
    if (!button || button.disabled) return;
    this.update(Number(this.dataset.quantity) + 1, {
      action: 'add',
      lines: [{ merchandiseId: this.dataset.variantId, quantity: 1 }],
    });
  };
}

if (!customElements.get('nemi-protection')) customElements.define('nemi-protection', NemiProtection);
if (!customElements.get('nemi-add-band')) customElements.define('nemi-add-band', NemiAddBand);
